import {useState} from "react";
import {Button, ButtonBase, Grid, TextField, Typography} from "@mui/material";
import {useResponsive} from "../../../../Modulo_Responsive/Hooks/useResponsive";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {collection, addDoc} from "firebase/firestore";
import {db} from "../../../../firebase/firebase";
import Boton_Fornulario from "./Boton_Fornulario";

const FUNCTION_URL = "https://us-central1-TU-PROYECTO.cloudfunctions.net/sendContactEmail";

const Formulario_Portada_Home = () => {
    const [loading, setLoading] = useState(false);
    const {sCell} = useResponsive()

    const [formData, setFormData] = useState({
        nombre: "",
        apellido: "",
        email: "",
        telefono: "",
        mensaje: "",
    });

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await addDoc(collection(db, "contacto"), formData);
            alert("¡Datos enviados!");
            setFormData({
                nombre: "",
                apellido: "",
                email: "",
                telefono: "",
                mensaje: "",
            });
        } catch (error) {
            console.error("Error al guardar datos", error);
            alert("Hubo un error.");
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{p: 3, ml: sCell ? 0 : 24, border: '1px solid #E8EAEE', borderRadius: 4, mt: sCell ? 4 : 0}}>
                {/*<Grid container size={{xs: 12, sm: 12, md: 12}}>*/}
                {/*    <Typography variant='h5'>*/}
                {/*        Te contacto*/}
                {/*    </Typography>*/}
                {/*</Grid>*/}
                <form onSubmit={handleSubmit}>
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{}}>


                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{pb: 2, pt: 4}}>
                            <TextField
                                name="nombre"
                                label="Nombre completo"
                                fullWidth
                                required
                                variant="outlined"
                                size="small" // Hace el campo más pequeño
                                sx={{
                                    backgroundColor: 'white',
                                    '& .MuiInputLabel-root': {
                                        color: '#D4D4D4',
                                        fontSize: '14px', // Hace el label más pequeño
                                        '&.MuiInputLabel-shrunk': {
                                            fontSize: '12px', // Label más pequeño cuando está contraído
                                        }
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: 1,
                                        height: '40px',

                                        // Controla la altura del campo
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#D4D4D4',
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#D4D4D4',
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#D4D4D4',
                                        },
                                        '& input': {
                                            color: 'black',
                                            padding: '8px 12px', // Reduce el padding interno
                                        },
                                    },

                                }}
                                value={formData.nombre}
                                onChange={handleChange}
                            />
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <TextField
                                name="email"
                                label="Correo electrónico"
                                fullWidth
                                required
                                type="email"
                                variant="outlined"
                                size="small"
                                sx={{
                                    backgroundColor: 'white',
                                    '& .MuiInputLabel-root': {
                                        color: '#D4D4D4',
                                        fontSize: '14px', // Hace el label más pequeño
                                        '&.MuiInputLabel-shrunk': {
                                            fontSize: '12px', // Label más pequeño cuando está contraído
                                        }
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: 1,
                                        height: '40px',

                                        // Controla la altura del campo
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#D4D4D4',
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#D4D4D4',
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#D4D4D4',
                                        },
                                        '& input': {
                                            color: 'black',
                                            padding: '8px 12px', // Reduce el padding interno
                                        },
                                    },

                                }}
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt: 2}}>
                            <TextField
                                name="mensaje"
                                label="Mensaje"
                                fullWidth
                                required
                                multiline
                                rows={4}
                                variant="outlined"
                                size="small"

                                sx={{
                                    color: 'black',
                                    backgroundColor: 'white',
                                    '& .MuiInputLabel-root': {
                                        color: '#D4D4D4', // color del label
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: 0, // sin bordes redondeados
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#D4D4D4',
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#D4D4D4',
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#D4D4D4',
                                        },
                                        '& input, & textarea': {
                                            color: 'black', // ahora también para multiline
                                        },
                                    },
                                }}
                                value={formData.mensaje}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sx={{pt: 4}}>
                          <Boton_Fornulario loading={loading}/>
                        </Grid>

                        {/*<Grid item xs={12} sx={{pt: 4}}>*/}
                        {/*    <ButtonBase type="submit" variant="contained"*/}
                        {/*                fullWidth*/}
                        {/*                sx={{backgroundColor: '#3E6AE1', color: 'white', p: 2}}>*/}
                        {/*        <Typography>*/}
                        {/*            Enviar*/}
                        {/*        </Typography>*/}
                        {/*        <ArrowForwardIcon/>*/}
                        {/*    </ButtonBase>*/}
                        {/*</Grid>*/}
                    </Grid>
                </form>
            </Grid>
        </Grid>
    )

}
export default Formulario_Portada_Home;